<template>
    <b-modal
        :hide-footer="true"
        :hide-header-close="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        :title="$t('Edit role')"
        centered
        id="edit-role"
        no-fade
        size="xl"
    >
        <template v-slot:default>
            <loading-animation
                :active.sync="loading"
                :is-full-page="false"
                :opacity="1"
                color="#5685D8"
            />
            <form @submit.prevent="editRole" ref="editRole">
                <b-form-group class="mb-2" label-for="name">
                    <template v-slot:label
                        >{{ $t("Nome") }}
                        <span class="text-danger">*</span></template
                    >
                    <b-form-input id="name" required v-model="role.name" />
                </b-form-group>
                <label
                    >{{ $t("Permissions") }}
                    <span class="text-danger">*</span></label
                >
                <div class="row m-0">
                    <div
                        class="col-md-4 p-3"
                        v-for="(key, index) in role.permissions"
                        style="border: 1px solid #eee"
                        :key="index"
                    >
                        {{ permissionsLabels[index] }}
                        <div class="float-right">
                            <toggle-button
                                :sync="true"
                                color="#5685D8"
                                id="status"
                                name="status"
                                v-model="role.permissions[index]"
                            />
                        </div>
                    </div>
                </div>

                <div class="float-right mt-3">
                    <router-link
                        class="btn btn-danger"
                        to="/dashboard/admin/roles"
                    >
                        <i class="mdi mdi-close" />
                        {{ $t("Cancel") }}
                    </router-link>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Update") }}
                    </button>
                </div>
            </form>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "Edit",
    mounted() {
        this.$bvModal.show("edit-role");
        this.getPermissions();
    },
    data() {
        return {
            loading: true,
            role: {
                name: null,
                permissions: []
            },
            permissionsLabels: [],
            permissions: []
        };
    },
    methods: {
        // Get permissions list
        getPermissions() {
            // Get all settings values
            axios.get("api/dashboard/roles/permissions").then(response => {
                this.permissions = response.data.data.controllers;
                this.permissionsLabels = response.data.data.controllerLabels;
                this.getRole();
            });
        },
        // Get role details
        getRole() {
            // Get role details
            axios
                .get("api/dashboard/roles/" + this.$route.params.id)
                .then(response => {
                    this.role = response.data.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                    this.$router.push("/dashboard/admin/roles");
                });
        },
        // Edit role
        editRole() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            // Send request
            axios
                .put("api/dashboard/roles/" + this.role.id, this.role)
                .then(response => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message
                    });
                    this.$router.push("/dashboard/admin/roles");
                    this.$parent.getRoles();
                });
        }
    }
};
</script>
